var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 187,
    viewBox: "0 0 246 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.04 38.437V42.2765H177.196V46.1202H173.352V49.9638H169.508V53.8076H165.665V57.6512H161.821V61.4949H154.133V65.3386H146.445V69.1823H134.914V73.026H119.543V69.1823H108.011V65.3386H100.323V61.4949H92.6358V57.6512H88.7919V53.8076H84.9481V49.9638H81.1042V46.1202H77.2604V42.2765H73.4166V38.437H61.885V119.15H192.571V38.437H181.04Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.04 42.2764V46.1201H177.196V49.9638H173.352V53.8075H169.509V57.6512H165.665V61.4949H161.821V65.3386H154.133V69.1823H146.446V73.026H134.914V76.8697H119.543V73.026H115.699H108.011V69.1823H100.324V65.3386H92.6359V61.4949H88.7921V57.6512H84.9482V53.8075H81.1044V49.9638H77.2605V46.1201H73.4167V42.2764H65.729V115.307H188.728V42.2764H181.04Z",
    fill: "#167FFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2603 57.6511H81.1041V61.4948H77.2603V57.6511Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4165 57.6511H77.2603V61.4948H73.4165V57.6511Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2603 53.8075H81.1041V57.6512H77.2603V53.8075Z",
    fill: "#C8C8C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9479 61.4948V57.6511H81.1041V61.4948H77.2603V65.3385H88.7918V61.4948H84.9479Z",
    fill: "#C8C8C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.167 73.0259H108.011V76.8695H104.167V73.0259Z",
    fill: "#E2CAB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.011 76.8696H111.855V84.557H108.011V76.8696Z",
    fill: "#E2CAB5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.729 42.2764H73.4168V46.1201H65.729V42.2764Z",
    fill: "#00FFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4165 46.1201H77.2603V49.9638H73.4165V46.1201ZM146.445 69.1822H154.133V73.026H146.445V69.1822ZM184.884 88.4007H188.728V92.2444H184.884V88.4007Z",
    fill: "#00FFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.196 84.557H184.884V88.4007H177.196V84.557Z",
    fill: "#00FFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.509 80.7133H177.196V84.557H169.509V80.7133Z",
    fill: "#00FFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.821 76.8696H169.508V80.7133H161.821V76.8696Z",
    fill: "#00FFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.133 73.0259H161.82V76.8695H154.133V73.0259Z",
    fill: "#00FFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4165 53.8075H77.2603V57.6512H73.4165V53.8075Z",
    fill: "#E1E1E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5729 57.6511V61.4948H65.729V65.3385H77.2605V61.4948H73.4167V57.6511H69.5729Z",
    fill: "#E1E1E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4165 49.9638H81.1041V53.8076H73.4165V49.9638Z",
    fill: "#7D00FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.729 46.1201H73.4167V49.9638H65.729V46.1201ZM146.446 73.026H154.133V76.8697H146.446V73.026ZM184.884 92.2444H188.728V96.0881H184.884V92.2444Z",
    fill: "#7D00FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.196 88.4006H184.884V92.2443H177.196V88.4006Z",
    fill: "#7D00FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.509 84.557H177.196V88.4007H169.509V84.557Z",
    fill: "#7D00FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.821 80.7133H169.508V84.557H161.821V80.7133Z",
    fill: "#7D00FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M154.133 76.8696H161.82V80.7133H154.133V76.8696Z",
    fill: "#7D00FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.699 76.8696H111.855V88.4007H119.542V84.557H115.699V76.8696Z",
    fill: "#D3AF90"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.699 73.0259H119.543V76.8695H115.699V73.0259Z",
    fill: "#D3AF90"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M154.133 65.3384H161.82V69.1821H154.133V65.3384ZM184.884 80.7132H188.727V84.5569H184.884V80.7132Z",
    fill: "#FFFF00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.196 76.8696H184.884V80.7133H177.196V76.8696ZM161.821 69.1822H169.508V73.0259H161.821V69.1822Z",
    fill: "#FFFF00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M169.509 73.0259H177.196V76.8695H169.509V73.0259Z",
    fill: "#FFFF00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184.884 76.8696H188.728V80.7133H184.884V76.8696Z",
    fill: "#FF00FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.196 73.0258H184.884V76.8695H177.196V73.0258ZM161.821 65.3384H169.508V69.1821H161.821V65.3384Z",
    fill: "#FF00FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.509 69.1822H177.196V73.0259H169.509V69.1822Z",
    fill: "#FF00FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M181.04 42.2764V46.1201H184.884V49.9638H188.728V42.2764H181.04ZM169.509 88.4007H161.821V92.2444H157.977V96.0881H173.352V92.2444H169.509V88.4007ZM81.1044 88.4007H77.2605V92.2444H73.4167V96.0881H84.9482V92.2444H81.1044V88.4007ZM73.4167 84.557H81.1044V80.7134H77.2605V76.8697H69.5729V73.026H65.729V88.4007H73.4167V84.557ZM184.884 53.8075H177.196V57.6512H173.352V61.4949H169.509V65.3386H177.196V69.1823H188.728V57.6512H184.884V53.8075ZM154.133 84.557H161.821V80.7134H154.133V76.8697H146.446V73.026H134.914V80.7134H131.07V84.557H138.758V88.4007H154.133V84.557ZM108.011 84.557H111.855V88.4007H108.011V84.557Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.888 84.557H188.728V88.4007H184.888V84.557Z",
    fill: "#00FF00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 80.7133H184.888V84.557H177.2V80.7133Z",
    fill: "#00FF00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M169.513 76.8696H177.2V80.7133H169.513V76.8696ZM154.137 69.1822H161.825V73.0259H154.137V69.1822Z",
    fill: "#00FF00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.825 73.0259H169.513V76.8696H161.825V73.0259ZM184.888 103.775H181.044V96.088H154.137V103.775H150.294V96.088H134.918V99.9317H138.762V107.619H134.918V111.463H131.074V115.307H142.606V107.619H146.45V115.307H157.981V107.619H161.825V115.307H173.357V107.619H177.2V115.307H188.728V96.088H184.888V103.775ZM165.669 107.619V99.9317H169.513V107.619H165.669ZM92.6359 103.775H88.7921V96.088H65.729V107.619H69.5729V115.307H81.1044V107.619H84.9482V115.307H96.4798V111.463H92.6359V107.619H96.4798V96.088H92.6359V103.775ZM73.4167 107.619V99.9317H77.2605V107.619H73.4167ZM111.855 103.775H119.543V107.619H111.855V103.775ZM131.074 103.775H123.387V111.463H115.699V115.307H127.231V107.619H131.074V103.775ZM104.167 111.463V107.619H108.011V103.775H100.324V115.307H111.855V111.463H104.167Z",
    fill: "#00FF00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M181.04 96.0881H184.884V103.776H181.04V96.0881ZM150.289 96.0881H154.133V103.776H150.289V96.0881ZM88.7921 96.0881H92.6359V103.776H88.7921V96.0881ZM165.665 99.9318H169.509V107.619H165.665V99.9318ZM73.4167 99.9318H77.2606V107.619H73.4167V99.9318ZM134.914 99.9318H138.758V107.619H134.914V99.9318ZM142.602 107.619H146.446V115.307H142.602V107.619ZM111.855 107.619H115.699V115.307H111.855V107.619ZM81.1044 107.619H84.9482V115.307H81.1044V107.619ZM157.977 107.619H161.821V115.307H157.977V107.619ZM173.352 107.619H177.196V115.307H173.352V107.619ZM65.729 107.619H69.5729V115.307H65.729V107.619ZM96.4798 111.463H100.324V115.307H96.4798V111.463ZM127.231 111.463H131.07V115.307H127.231V111.463Z",
    fill: "#00B900"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M119.543 84.557V88.4007H108.011V84.557H104.167V92.2444H108.011V96.0881H119.543V92.2444H123.386V84.557H119.543Z",
    fill: "#323232"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4795 73.0259H100.323V76.8695H96.4795V73.0259Z",
    fill: "#F8ECE0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M131.07 92.2444V88.4007H123.386V92.2444H119.543V96.0881H108.011V92.2444H104.167V88.4007H100.323V84.557H96.4795V76.8696H88.7919V69.1822H84.948V80.7133H88.7919V88.4007H92.6357V96.0881H96.4795V107.619H92.6357V111.463H100.323V103.775H108.011V107.619H104.167V111.463H111.855V103.775H119.543V107.619H115.699V111.463H123.386V103.775H131.07V107.619H127.23V111.463H134.914V92.2444H131.07Z",
    fill: "#F8ECE0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0412 38.437V42.2765H54.1973V46.1202H50.3535V73.026H58.0412V69.1823H61.885V38.437H58.0412Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0411 42.2764V46.1201H54.1973V69.1823H58.0411V65.3386H61.8849V42.2764H58.0411Z",
    fill: "#167FFE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8849 61.4949H58.0411V57.6512H54.1973V69.1823H58.0411V65.3386H61.8849V61.4949ZM61.8849 42.2764H58.0411V46.1201H54.1973V49.9638H61.8849V42.2764Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M200.259 46.1202V42.2765H196.415V38.437H192.571V69.1823H196.415V73.026H204.103V46.1202H200.259Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 46.1201V42.2764H192.571V65.3386H196.415V69.1823H200.259V46.1201H196.415Z",
    fill: "#167FFE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 42.2764H192.571V46.1201H196.415V42.2764Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M200.259 49.9638H196.415V53.8076H200.259V49.9638Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 57.6511H192.571V61.4948H196.415V57.6511Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2815 78.7914V74.9477H38.4376V71.104H34.5938V67.2604H30.7499V63.4167H26.9065V59.5729H19.2188V63.4167H15.375V67.2604H11.5311V71.104H7.68771V74.9477H3.84384V78.7914H0V101.854H3.84384V105.697H7.68771V109.541H11.5311V113.385H15.375V117.228H19.2188V121.072H26.9065V117.228H30.7499V113.385H34.5938V109.541H38.4376V105.697H42.2815V101.854H46.1245V78.7914H42.2815Z",
    fill: "#339CF0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2187 101.854V98.01H15.3749V105.697H11.531V109.541H15.3749V113.385H19.2187V117.228H23.0625V101.854H19.2187Z",
    fill: "#DCDCDC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 94.1661H15.375V98.0098H11.5312V94.1661ZM7.68774 101.854H11.5312V105.697H7.68774V101.854Z",
    fill: "#DCDCDC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68761 94.1663H11.531V90.3226H7.68761V86.4789H3.84375V101.854H7.68761V94.1663Z",
    fill: "#DCDCDC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4376 86.4789V90.3226H34.5938V94.1663H38.4376V101.854H42.2815V86.4789H38.4376Z",
    fill: "#F5F5F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 94.1661H34.5939V98.0098H30.75V94.1661ZM34.5939 101.854H38.4378V105.697H34.5939V101.854Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7498 98.01H26.9059V101.854H23.0625V117.228H26.9059V113.385H30.7498V109.541H34.5936V105.697H30.7498V98.01Z",
    fill: "#F5F5F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 82.6352H42.2813V86.4789H38.4375V82.6352Z",
    fill: "#B9B9B9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5938 86.4789H38.4376V90.3226H34.5938V86.4789Z",
    fill: "#B9B9B9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7498 90.3226H34.5936V94.1662H30.7498V90.3226ZM11.531 90.3226H15.3748V94.1662H11.531V90.3226Z",
    fill: "#B9B9B9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3748 94.1661H19.2186V98.0098H15.3748V94.1661Z",
    fill: "#B9B9B9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2189 98.0099V101.854H26.9061V98.0099H19.2189ZM7.68774 86.4789H11.5312V90.3226H7.68774V86.4789Z",
    fill: "#B9B9B9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 82.6352H7.68762V86.4789H3.84375V82.6352ZM26.9064 94.1663H30.7498V98.0099H26.9064V94.1663Z",
    fill: "#B9B9B9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4387 78.7915V74.9478H34.5949V71.1041H30.7511V67.2604H26.9076V63.4167H19.2199V67.2604H15.3761V71.1041H11.5322V74.9478H7.68881V78.7915H3.84497V82.6352H7.68881V86.4789H11.5322V90.3226H15.3761V94.1663H19.2199V98.01H26.9076V94.1663H30.7511V90.3226H34.5949V86.4789H38.4387V82.6352H42.2826V78.7915H38.4387Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0626 86.4789H19.2188V90.3226H23.0626V86.4789Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3748 78.7914H11.531V82.6351H15.3748V78.7914Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2186 82.6352H15.3748V86.4789H19.2186V82.6352Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0626 71.104H19.2188V74.9477H23.0626V71.104Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2186 74.9478H15.3748V78.7915H19.2186V74.9478Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.875 144.134V140.291H73.0312V136.447H46.1243V140.291H42.2813V144.134H38.4375V171.04H42.2813V178.728H46.1243V182.571H53.812V186.415H65.3435V182.571H73.0312V178.728H76.875V171.04H80.7189V144.134H76.875Z",
    fill: "#511F17"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1876 151.822H73.0314V155.665H69.1876V151.822ZM42.2815 167.196H46.1245V155.665H42.2815V167.196ZM49.9684 163.353H53.8122V155.665H49.9684V163.353ZM57.656 171.04H61.4999V159.509H57.656V171.04ZM65.3438 159.509H69.1876V163.353H65.3438V159.509ZM73.0314 159.509V167.196H76.8753V159.509H73.0314ZM49.9684 178.727H53.8122V167.196H49.9684V178.727ZM65.3438 174.884H69.1876V167.196H65.3438V174.884ZM57.656 182.571H61.4999V174.884H57.656V182.571Z",
    fill: "#7A500C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0314 144.134V140.291H46.1245V144.134H42.2815V147.978H46.1245V151.822H73.0314V147.978H76.8753V144.134H73.0314Z",
    fill: "#955C4B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0314 144.134H46.1245V147.978H73.0314V144.134Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1245 117.228H42.2815V121.072H46.1245V117.228Z",
    fill: "#FF89FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2813 121.072H38.4375V124.916H42.2813V121.072Z",
    fill: "#FF89FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9683 121.072H46.1245V128.759H49.9683V121.072Z",
    fill: "#FF89FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4376 124.916H34.5938V128.759H38.4376V124.916Z",
    fill: "#FF89FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8121 128.759H49.9683V136.447H53.8121V128.759Z",
    fill: "#FF89FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M57.656 136.447H53.8123V144.134H57.656V136.447Z",
    fill: "#FF89FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4998 144.134H57.656V147.978H61.4998V144.134Z",
    fill: "#FF89FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M219.479 146.056V142.212H215.635V138.369H211.791V134.525H207.947V130.681H184.884V134.525H181.04V138.369H177.196V142.212H173.352V146.056H169.509V169.118H173.352V172.962H177.196V176.806H181.04V180.649H184.884V184.493H207.947V180.649H211.791V176.806H215.635V172.962H219.479V169.118H223.322V146.056H219.479Z",
    fill: "#646464"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.635 146.056V142.212H211.791V138.369H207.947V134.525H184.884V138.369H181.04V142.212H177.196V146.056H173.352V169.118H177.196V172.962H181.04V176.806H184.884V180.649H207.947V176.806H211.791V172.962H215.635V169.118H219.478V146.056H215.635Z",
    fill: "#B4B4B4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.415 159.509V174.884H200.259V171.04H204.103V167.196H207.947V163.353H211.79V159.509H196.415Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M173.352 142.212H177.196V146.056H173.352V142.212ZM192.571 144.134H188.728V147.978H184.884V151.822H181.04V159.509H196.415V140.291H192.571V144.134Z",
    fill: "#646464"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M181.044 159.509V163.353H184.888V167.196H188.728V171.04H192.572V174.884H196.415V159.509H181.044Z",
    fill: "#323232"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M207.947 151.822V147.978H204.103V144.134H200.259V140.291H196.415V159.509H211.79V151.822H207.947Z",
    fill: "#323232"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M211.405 65.3384V107.619H215.249V111.463H219.093V115.306H222.937V119.15H234.468V115.306H238.312V111.463H242.156V107.619H246V65.3384H211.405Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M215.249 73.0259V99.9317H242.156V73.0259H215.249Z",
    fill: "#323232"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M222.937 92.2444H234.468V96.0881H222.937V92.2444ZM222.937 76.8696H234.468V80.7133H222.937V76.8696ZM222.937 84.557H234.468V88.4007H222.937V84.557Z",
    fill: "#00FF00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8071 0V7.68741H75.3386V15.3748H79.1825V23.0621H83.0263V26.9059H86.8702V30.7495H113.777V26.9059H117.621V23.0621H121.465V15.3748H125.309V7.68741H132.992V15.3748H136.836V23.0621H140.68V26.9059H144.524V30.7495H171.431V26.9059H175.274V23.0621H179.118V15.3748H182.962V7.68741H194.494V0H63.8071Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M175.274 3.84357V11.531H171.43V7.68729H167.586V3.84357H175.274Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M117.621 3.84357V11.531H113.777V7.68729H109.933V3.84357H117.621Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M116.084 184.108V180.264H112.24V176.42H108.396V161.816H112.24V157.972H116.084V141.827H112.24V138.754H142.22V141.827H138.376V157.972H142.22V161.816H146.064V176.42H142.22V180.264H138.376V184.108H116.084Z",
    fill: "#BE00AF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M141.835 139.139V141.061H138.762H137.992V142.212V157.587V158.353H138.762H141.835V161.431V162.197H142.606H145.679V175.65H142.606H141.835V176.806V179.879H138.762H137.992V180.649V183.723H116.465V180.649V179.879H115.699H112.621V176.806V176.035H111.855H108.782V162.197H111.855H112.621V161.431V158.353H115.699H116.465V157.587V142.212V141.442H115.699H112.621V139.139H141.835ZM142.606 138.369H111.855V142.212H115.699V157.587H111.855V161.431H108.011V176.806H111.855V180.649H115.699V184.493H138.762V180.649H142.606V176.806H146.45V161.431H142.606V157.587H138.762V142.212H142.606V138.369Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M127.23 146.056V142.212H119.543V153.744H127.23V149.9H123.387V146.056H127.23Z",
    fill: "#B1D0EA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M131.074 142.212V146.056H127.23V149.9H131.074V153.744H134.918V142.212H131.074Z",
    fill: "#6EA8D8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M123.386 134.525H127.23V138.369H123.386V134.525ZM123.386 146.056H127.23V149.9H123.386V146.056Z",
    fill: "#FA34F3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M127.231 142.212H131.074V146.056H127.231V142.212ZM131.074 130.681H134.918V134.525H131.074V130.681ZM131.074 149.9H127.231V153.743H119.543V161.431H115.699V172.962H119.543V176.806H131.074V172.962H134.918V161.431H131.074V149.9Z",
    fill: "#FA34F3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M138.762 161.431V157.587H134.918V153.744H131.074V161.431H134.918V172.962H131.074V176.806H119.542V172.962H115.699V161.431H111.855V176.806H115.699V180.649H138.762V176.806H142.605V161.431H138.762Z",
    fill: "#BE00AF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M115.699 157.587H119.543V161.431H115.699V157.587Z",
    fill: "#BE00AF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M111.855 157.587H115.699V161.431H111.855V157.587ZM111.855 176.806H115.699V180.649H111.855V176.806Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M119.543 142.212H134.918V157.587H138.762V142.212H142.606V138.369H111.855V142.212H115.699V157.587H119.543V142.212ZM108.011 161.431H111.855V176.806H108.011V161.431ZM142.606 161.431H146.45V176.806H142.606V161.431Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M138.762 176.806H142.606V180.649H138.762V176.806ZM138.762 157.587H142.606V161.431H138.762V157.587Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M115.699 180.649H138.762V184.493H115.699V180.649Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyItems);
export default __webpack_public_path__ + "static/media/my-items.83798f102e7a9c7a5d4debba2569f6e7.svg";
export { ForwardRef as ReactComponent };